
const Slider = resolve => {
    require.ensure(['../views/apps/slider/Slider'], () => {
        resolve(require('../views/apps/slider/Slider'))
    })
};
const SliderTanimla = resolve => {
    require.ensure(['../views/apps/slider/SliderTanimla'], () => {
        resolve(require('../views/apps/slider/SliderTanimla'))
    })
};

const SliderListe = resolve => {
    require.ensure(['../views/apps/slider/SliderListe'], () => {
        resolve(require('../views/apps/slider/SliderListe'))
    })
};

const SliderDuzenle = resolve => {
    require.ensure(['../views/apps/slider/SliderDuzenle'], () => {
        resolve(require('../views/apps/slider/SliderDuzenle'))
    })
};
import Vue from 'vue'

Vue.component('SliderTanimla', SliderTanimla);
Vue.component('SliderListe', SliderListe);
Vue.component('SliderDuzenle', SliderDuzenle);

import layouts from '../layout'

export default {
    path: '/slider',
    name: 'slider',
    component: Slider,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: 'tanimlama',
            name: 'slidertanimlama',
            component: SliderTanimla,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: 'liste',
            name: 'sliderliste',
            component: SliderListe,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: 'guncelleme',
            name: 'sliderguncelleme',
            component: SliderDuzenle,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },

    ],

}
